export default class ProtocolWhatsappButton {
  constructor (view, setup) {
    this.view = view
    this.setup = setup
  }

  onStart () {
    const _view = this.view
    const _setup = this.setup

    const websocket = new WebSocket(_setup.websocket_url)

    websocket.onopen = function () {
      if (websocket) {
        const data = JSON.stringify({
          type: _setup.type,
          channel: _setup.channel
        })
        websocket.send(data)
      }
    }

    websocket.onmessage = function (event) {
      const data = JSON.parse(event.data)
      if (data.type === 'res_configuration_wsp') {
        if (data.channel.whatsAppButtonEnabled) {
          _view.channelEnabled = data.channel.enabled
          _view.enabled = data.channel.whatsAppButtonEnabled
          _view.configuration = data.channel.whatsAppButtonConfiguration
          _view.number = data.channel.phone_number.replace('whatsapp:+', '')
        }
        websocket.close(3001)
      }
    }
  }
}
